import * as React from 'react';
import {SiteSearchConfig} from "../../empracoTypes";
import {GroupedResponse} from "./site-search-request";

interface CurrentSiteSearchContextModel {
  config: SiteSearchConfig;
  response: GroupedResponse[];
}

export const CurrentSiteSearchContext =
  React.createContext<CurrentSiteSearchContextModel | undefined>(undefined);

export const useCurrentSiteSearchContext = (): CurrentSiteSearchContextModel => {
  const context = React.useContext(CurrentSiteSearchContext);

  if (!context) {
    throw new Error('"useCurrentSiteSearchContext" must be used within the site search control.');
  }

  return context;
}